import { render } from "./ProspectusSearch.vue?vue&type=template&id=01343354"
import script from "./ProspectusSearch.vue?vue&type=script&lang=js"
export * from "./ProspectusSearch.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\FinanssivalvontaCMS12\\Finanssivalvonta.web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__